export default "__VITE_ASSET__Cq13FVIg__"